import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../../common/Input';
import { getCities } from '../../../utils/functions';

const Address = ({
  formData,
  invalidFields,
  handleChange,
  handleBlur,

  isItalia,
  nations
}) => {
  const { t } = useTranslation();

  const [availableZipCodes, setAvailableZipCodes] = React.useState([]);

  const handleNationChange = (field, value) => {
    handleChange(field, value);
    handleChange('province', '');
    handleChange('city', '');
    handleChange('zipCode', '');
    handleChange('licenseIssuedBy', '');
    handleChange('documentIssuedBy', '');
    setAvailableZipCodes([]);
  };

  const handleCityChange = (field, value, callback) => {
    handleChange(field, value);
    handleChange('province', '');
    setAvailableZipCodes([]);
    if (!isItalia) return;

    // Lookup for cities
    getCities(value).then(res => callback(res));
  };

  const handleCitySelect = (option) => {
    handleChange('city', option.comune);
    handleChange('province', option.provincia);

    const zipCodes = option.cap.split(',');
    setAvailableZipCodes(zipCodes);
    zipCodes.length > 0 && handleChange('zipCode', zipCodes[0]);
  };

  const handleTaxCodeChange = (field, value) => {
    handleChange(field, value.toUpperCase());
  };

  useEffect(() => {
    if (!isItalia) return;
    if (!formData.city) return;
    if (!formData.zipCode) return;
    if (availableZipCodes.length > 0) return;

    getCities(formData.city).then(res => {
      if (!res.length) return;
      setAvailableZipCodes(res[0].value.cap.split(','));
    });
  }, [isItalia, formData.city, formData.zipCode, availableZipCodes]);

  return <div className='customer__form__data data--address'>
    <Input
      type='select'
      name='nation'
      label={formData.type === 'company' ? t('customer.form.companyNation.label') : t('customer.form.nation.label')}
      helper={formData.type === 'company' ? t('customer.form.companyNation.helper') : t('customer.form.nation.helper')}
      value={formData.nation}
      invalid={invalidFields['nation']}
      options={['', ...nations]}
      onChange={handleNationChange}
      onBlur={handleBlur}
    />
    <Input
      type={isItalia ? 'autocomplete' : 'text'}
      name='city'
      label={formData.type === 'company' ? t('customer.form.companyCity.label') : t('customer.form.city.label')}
      value={formData.city}
      invalid={invalidFields['city']}
      onChange={handleCityChange}
      onSelect={handleCitySelect}
      onBlur={handleBlur}
    />
    {isItalia && <Input
      type='text'
      name='province'
      label={t('customer.form.province.label')}
      value={formData.province}
      invalid={invalidFields['province']}
      disabled
    />}
    <Input
      type={!isItalia || availableZipCodes.length === 1 ? 'text' : 'select'}
      name='zipCode'
      label={t('customer.form.zipCode.label')}
      value={formData.zipCode}
      invalid={invalidFields['zipCode']}
      options={availableZipCodes}
      disabled={isItalia && availableZipCodes.length === 1}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    <div className='customer__form__data__address'>
      <Input
        type='text'
        name='address'
        label={formData.type === 'company' ? t('customer.form.companyAddress.label') : t('customer.form.address.label')}
        value={formData.address}
        invalid={invalidFields['address']}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type='text'
        name='streetNumber'
        label={t('customer.form.streetNumber.label')}
        value={formData.streetNumber}
        invalid={invalidFields['streetNumber']}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
    {isItalia && ['driver', 'individual', 'sole-proprietorship'].includes(formData.type) && <Input
      type='text'
      name='taxCode'
      label={t('customer.form.taxCode.label')}
      value={formData.taxCode}
      invalid={invalidFields['taxCode']}
      onChange={handleTaxCodeChange}
      onBlur={handleBlur}
    />}
    {['sole-proprietorship', 'company'].includes(formData.type) && <Input
      type='text'
      name='vatNumber'
      label={t('customer.form.vatNumber.label')}
      value={formData.vatNumber}
      invalid={invalidFields['vatNumber']}
      onChange={handleChange}
      onBlur={handleBlur}
    />}
  </div>;
};

export default Address;
